import { useEffect, useRef } from 'react';

const useMagneticCursor = () => {
  const mouseRef = useRef({ x: 0, y: 0 });
  const rafRef = useRef(null);

  useEffect(() => {
    const THRESHOLD = 150;
    const STRENGTH = 0.35;
    const RETURN_SPEED = 0.15;

    // Track mouse position
    const handleMouseMove = (e) => {
      mouseRef.current = { x: e.clientX, y: e.clientY };
    };

    window.addEventListener('mousemove', handleMouseMove);

    // Store element states
    const elementStates = new Map();

    const animate = () => {
      const elements = document.querySelectorAll('[data-magnetic]');
      
      elements.forEach((element) => {
        const rect = element.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;
        
        const distX = mouseRef.current.x - centerX;
        const distY = mouseRef.current.y - centerY;
        const distance = Math.sqrt(distX * distX + distY * distY);
        
        // Get or create state for this element
        if (!elementStates.has(element)) {
          elementStates.set(element, { x: 0, y: 0 });
        }
        const state = elementStates.get(element);
        
        let targetX = 0;
        let targetY = 0;
        
        if (distance < THRESHOLD) {
          // Calculate magnetic pull force
          const force = (1 - distance / THRESHOLD) * STRENGTH;
          targetX = distX * force;
          targetY = distY * force;
        }
        
        // Spring-like easing toward target
        state.x += (targetX - state.x) * RETURN_SPEED;
        state.y += (targetY - state.y) * RETURN_SPEED;
        
        // Apply transform only if movement is significant
        if (Math.abs(state.x) > 0.01 || Math.abs(state.y) > 0.01) {
          element.style.transform = `translate(${state.x}px, ${state.y}px)`;
        } else {
          element.style.transform = '';
        }
      });
      
      rafRef.current = requestAnimationFrame(animate);
    };

    rafRef.current = requestAnimationFrame(animate);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      if (rafRef.current) {
        cancelAnimationFrame(rafRef.current);
      }
      // Reset all elements
      document.querySelectorAll('[data-magnetic]').forEach((el) => {
        el.style.transform = '';
      });
    };
  }, []);
};

export default useMagneticCursor;
